import { render, staticRenderFns } from "./@PopupSendCustomer.vue?vue&type=template&id=027c5030&scoped=true&"
import script from "./@PopupSendCustomer.vue?vue&type=script&lang=js&"
export * from "./@PopupSendCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c5030",
  null
  
)

export default component.exports